class LocalStorageFormReplacement {
  constructor(form, block) {
    this.saveValueInput = {};
    this.form = form;
    this.block = block;
    this.flag = true;
  }

  save_value_input() {
    let self = this;
    let idBlock = this.block.attr('id');
    let idForm = this.form.closest('form').attr('id');
    this.saveValueInput[idBlock] = {};

    $(this.form).each(function(index, input) { 
      let $input = $(input);
      let isCheckBox = $input.attr("type") == "checkbox";
      let valueInput;

      if(self.block.attr('id') == 'utm-marks-block' && $input.attr('id') == "adv_channel_utm_marks") return;
      if(isCheckBox) {
        valueInput = $input.is(":checked");
      } else {
        valueInput = $input.val();
      }

      self.saveValueInput[idBlock][index] = valueInput;
    });
    localStorage.setItem(`replacement_value_${idForm}_${idBlock}`, JSON.stringify(this.saveValueInput));
  }

  cleanup_all_elements() {
    let idBlock = this.block.attr("id");
    switch(idBlock) {
      case 'trans_sourse_block_wrapper':
        this.block.find('input:checked').prop('checked', false);
        $("#trans_sourse_block_wrapper").find('.setting-item').remove();
        break;
      case 'regions_block':
        this.block.find('.setting-item').remove();
        break;
      case 'utm-marks-block':
        this.block.find('.utm-mark-item').remove();
        break;
    }
  }

  get_save_value_input() {
    let idBlock = this.block.attr("id");
    let idForm = this.form.closest('form').attr('id');

    let inputsStorage = JSON.parse(localStorage.getItem(`replacement_value_${idForm}_${idBlock}`))[idBlock];

    for (let input in inputsStorage) {
      let $input = $(this.form[input]);
      let value = inputsStorage[input];
      let isCheckBox = $input.attr("type") === "checkbox";

      if(isCheckBox) {
        $input.prop('checked', value);
      } else {
        this.adding_data_in_dinamic_input($input, value);
      }
    }
  }

  adding_data_in_dinamic_input(input, value) {
    let idBlock = this.block.attr("id");
    let inputAddDomain = $("#input_add_domain");
    let inputAddRegions = $("#input_add_regions");
    let btnConfirm = this.block.find('.btn_comfurn');

    window.show_add_item_block(this.block.find('.add-setting-btn'));

    switch(idBlock) {
      case 'trans_sourse_block_wrapper':
        inputAddDomain.val(value);
        window.add_item_setting(btnConfirm, 'adv_channel[referrer][]', 'referrer');
        break;
      case 'regions_block':
        inputAddRegions.val(value);
        window.add_item_setting(btnConfirm, 'adv_channel[geo][]', 'geo');
        break;
      case 'utm-marks-block':
        if(this.flag) {
          this.flag = false;
          window.add_utm_mark();
          let $lastSelect = $('.custom-select-input:last');
          $lastSelect.find(`option[value="${value}"]`).attr("selected", "selected");
          $lastSelect.parent().find('.custom-select-toggle-wrapper').text(value);
        } else {
          this.flag = true;
          $(document.activeElement).val(value);
        }
        break;
    }
  }
}

export default LocalStorageFormReplacement;